export const enum DeviceTypes {

    MOBILE,
    TABLET,
    DESKTOP,

}
